// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._8QkiFa2muYJRb8v-tWZcPQ\\=\\={margin-right:0 !important;margin-left:0 !important}", "",{"version":3,"sources":["webpack://./components/Row/styles.module.scss"],"names":[],"mappings":"AACA,6BACE,yBAAA,CACA,wBAAA","sourcesContent":["// https://github.com/ant-design/ant-design/issues/10144\n.avoidGutterHorizontalScroll {\n  margin-right: 0 !important;\n  margin-left: 0 !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"avoidGutterHorizontalScroll": "_8QkiFa2muYJRb8v-tWZcPQ=="
};
export default ___CSS_LOADER_EXPORT___;
